import React, { useState, useEffect } from "react";
import { Paper, Text, Button, Group, Stack, Title } from "@mantine/core";
import { djangoAxiosInstance } from "../api";

const TrialStatus = () => {
  const [trialInfo, setTrialInfo] = useState({
    isNewUser: false,
    free_calls: 0,
    tenant: false,
    subscription_seat: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrialStatus = async () => {
      try {
        setLoading(true);
        const accessToken = localStorage.getItem("access_token");
        const headers = {};
        if (accessToken) {
          headers["Authorization"] = `Bearer ${accessToken}`;
        }

        const response = await djangoAxiosInstance.get("/users/me", {
          headers,
        });
        setTrialInfo(response.data);
      } catch (error) {
        console.error("Error fetching trial status:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrialStatus();
  }, []);

  if (
    loading ||
    trialInfo.subscription_seat
  )
  {
    return null;
  }

  return (
    <Paper p="sm" withBorder radius="md">
      {trialInfo.free_calls > 0 ? (
        <Stack justify="center" align="center">
          <Title
            order={2}
            ta="center"
            ff="DM Sans, sans-serif"
            fw={600}
            lts={-1}
            opacity={0.9}
          >
            {trialInfo.free_calls} Free Requests Left
          </Title>
          <Group gap="md" justify="center" align="center">
            <Text size="md" align="center">
              Need more? <strong>Upgrade anytime</strong> to unlock unlimited
              access.
            </Text>
          </Group>
          <Group justify="center">
            <Text>
              Once you've used all 5 requests, you'll be prompted to select a
              plan.
            </Text>
          </Group>
          <Group mt="md">
            <Button
              variant="filled"
              style={{ backgroundColor: "rgba(15,45,45,.9)" }}
              component="a"
              href="/app/checkout"
            >
              Upgrade Now
            </Button>
          </Group>
          <Text size="xs" c="dimmed" fs="italic">
            (This message will update as you use requests.)
          </Text>
        </Stack>
      ) : (
        <Stack justify="center" align="center">
          <Title order={3} size="h4" fw={600}>
            Your Free Trial Has Ended
          </Title>
          <Group justify="center">
            <Text>
            You've used all <strong>5 free requests</strong> — but your AI-powered
            legal assistant is just getting started.
            </Text>
          </Group>
          <Text size="md">
             Unlock unlimited access and
            keep drafting seamlessly with one of our plans.
          </Text>
          <Group mt="md">
            <Button
              variant="filled"
              style={{ backgroundColor: "rgba(15,45,45,.9)" }}
              component="a"
              href="/app/checkout"
            >
              Select a Plan
            </Button>
          </Group>
        </Stack>
      )}
    </Paper>
  );
};

export default TrialStatus;
